import { ThunkedAction } from '../../interfaces/redux.interface';
import httpService from '../../services/http.service';
import * as ClientWorkingTimeActions from '../constants/clientWorkingTime';
import { getAuthToken } from '../selectors/login.selectors';
import { getRepresentUnitId } from './workingTime.action';

const getClientWorkingTimeSuccess = (payload: any[]) => ({
	type: ClientWorkingTimeActions.GET_CLIENT_WORKING_TIME_SUCCESS,
	payload,
});


const getClientCompareCompaniesData = (payload: any[]) => ({
	type: ClientWorkingTimeActions.GET_CLIENT_COMPARE_COMPANIES_SUCCESS,
	payload,
});

interface FetchClientWorkingTimeParams {
	clientnumber: number;
	user_id: number | string;
	period: 'monthly' | 'daily';
	year?: number;
	month?: number; // If month is provided with period='monthly', it's monthly data. If omitted, it's yearly data.
	date_from?: string;
	date_to?: string;
}

interface DateCriteria {
	date_from: string;
	date_to: string;
	key: string;
}

interface FetchClientCompareCompaniesParams {
	user_id: number | string;
	period: 'monthly' | 'daily';
	clientnumber: number | string;
	criterias: DateCriteria[];
	selectedTab?: number;
}

function getMonthRange(year: number, month: number) {
  const startDate = new Date(year, month - 1, 1);
  const endDate = new Date(year, month, 0);

  return {
    start: formatLocal(startDate),
    end: formatLocal(endDate),
  };
}

function getYearRange(year: number) {
  const startDate = new Date(year, 0, 1);   
  const endDate   = new Date(year, 12, 0);  

  return {
    start: formatLocal(startDate),
    end: formatLocal(endDate),
  };
}


function formatLocal(date: any) {
  return (
    date.getFullYear() + '-' +
    String(date.getMonth() + 1).padStart(2, '0') + '-' +
    String(date.getDate()).padStart(2, '0')
  );
}

export const fetchClientWorkingTimeData = (
	params: FetchClientWorkingTimeParams,
): ThunkedAction => {
	const { user_id, clientnumber, period, year, month, date_from, date_to } = params;

	return async (dispatch, getState) => {
		const token = getAuthToken(getState());
		const unitId = await getRepresentUnitId();

		const query: any = {
			key: token,
			period: period,
			operatorId: clientnumber,
			unitIds: unitId,
			user_id: user_id
			
		};

		if (period === 'monthly') {
			query.year = year || new Date().getFullYear()
			if (month !== undefined) {
				const { start, end } = getMonthRange(year || new Date().getFullYear(), month);
				query.date_from = start;
				query.date_to = end;
			} else {
				// Yearly data
				const { start, end } = getYearRange(year || new Date().getFullYear());
				query.date_from = start;
				query.date_to = end;
			}
		} else if (period === 'daily') {
			query.date_from = date_from;
			query.date_to = date_to;
		}

		httpService
			.api<any[]>({
				type: 'getSpecificClientSummary',
				query: query,
			})
			.then(data => {
				dispatch(getClientWorkingTimeSuccess(data));
			})
			.catch(() => {});
	};
};

export const fetchClientCompareCompaniesData = (
	params: FetchClientCompareCompaniesParams,
): ThunkedAction => {
	const { user_id, period, clientnumber, criterias, selectedTab } = params;

	return async (dispatch, getState) => {
		const token = getAuthToken(getState());
		const unitId = await getRepresentUnitId();

		const body = {
			period,
			operatorId: clientnumber,
			user_id: user_id,
			unitIds: unitId,
			criterias,
		};
		httpService
			.api<any[]>({
				type: 'getClientCompareCompaniesSummary',
				method: 'POST',
				data: body,
				query: { key: token },
			})
			.then(data => {
				dispatch(getClientCompareCompaniesData({
					data,
					selectedTab: selectedTab ?? 2,
				}));
			})
			.catch(() => {});
	};
};
